import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import axios from 'axios';
import { BASE_API_URL } from '../../utils/constants';
import { logoutUser } from './authService';
import { myFirebaseAuth } from '../../firebase/config';
import { TradeReferenceUpdate } from '@dill/dill-shared';

export const getTradeReferences = createAsyncThunk(
  'tradeReferences/getTradeReferences',
  async ({ supplierId }: { supplierId: string }, thunkApi) => {
    const token = await myFirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      return null;
    }
    try {
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/tradeReferences/getTradeReferences`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            supplierId,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const uploadTradeReferences = createAsyncThunk(
  'tradeReferences/uploadTradeReferences',
  async (
    {
      folderPath,
      folderExcelName,
      supplierId,
    }: { folderPath: string; folderExcelName: string; supplierId: string },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.post<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/tradeReferences/uploadTradeReferences`,
        { folderPath, folderExcelName },
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const updateTradeReference = createAsyncThunk(
  'tradeReferences/updateTradeReference',
  async (
    {
      supplierId,
      tradeReferenceId,
      tradeReferenceDetails,
    }: {
      supplierId: string;
      tradeReferenceId: string;
      tradeReferenceDetails: TradeReferenceUpdate;
    },
    thunkApi
  ) => {
    const token = await myFirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      return null;
    }

    try {
      const response = await axios.put<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/tradeReferences/updateTradeReference/${tradeReferenceId}`,
        { ...tradeReferenceDetails },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const deleteTradeReference = createAsyncThunk(
  'tradeReferences/deleteTradeReference',
  async (
    {
      supplierId,
      tradeReferenceId,
    }: {
      supplierId: string;
      tradeReferenceId: string;
    },
    thunkApi
  ) => {
    const token = await myFirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      return null;
    }

    try {
      const response = await axios.delete<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/tradeReferences/deleteTradeReference/${tradeReferenceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
